module.exports = __webpack_public_path__ + "img/cf3ba28.jpg";